<template>
  <div class="horizbox">
    <el-row type="flex" class="row-bg">
      <el-col :span="4" :xs="24">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="paramsObj.keyword" placeholder="支持款式搜索" @keyup.enter="fetch"
            style="max-width: 120px;"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="5" :xs="24">
        <el-tree-select ref="companys" v-model="paramsObj.companyId" :data="companys" @change="fetch"
          check-strictly :render-after-expand="false" placeholder="请选择公司" style="width:250px" />
      </el-col>

      <el-col :span="3" :xs="24">
        <el-select v-model="paramsObj.storeCode" placeholder="请选择库房" size="default" @change="fetch" clearable
          style="max-width: 120px;">
          <el-option v-for="item in store" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" :xs="24">
        <el-select v-model="paramsObj.channel" placeholder="渠道" size="default" @change="fetch" clearable
          style="max-width: 120px;">
          <el-option v-for="item in channels" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-col>

      <el-col :span="5" :xs="24">
        <el-date-picker v-model="valueTime" type="daterange" @calendar-change="fetch" change="fetch"
          unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD"
          :shortcuts="$util.getShortCuts()" size="default" style="max-width: 210px;">
        </el-date-picker>
      </el-col>

      <el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">
        <el-button style="margin: 0 10px" size="default" type="primary" @click="fetch"> 确认 </el-button>
      </el-col>
    </el-row>

    <el-table class="table" :data="storedata" border size="small" show-summary :summary-method="getSummaries">
      <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column>
      <el-table-column prop="name" label="渠道名称" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="productPrice" label="在库综合成本" width="90" align="right">
        <template #default="row">{{ toBigNumber(row.row.productPrice) }}</template>
      </el-table-column>
      <el-table-column prop="purchasePrice" label="在库采购成本" width="90" align="right">
        <template #default="row">{{ toBigNumber(row.row.purchasePrice) }}</template>
      </el-table-column>
      <el-table-column prop="orderCount" label="订单数" width="60" align="center"></el-table-column>
      <el-table-column prop="orderSellPrice" label="订单金额" width="70" align="right">
        <template #default="row">{{ toBigNumber(row.row.orderSellPrice) }}</template>
      </el-table-column>
      <el-table-column prop="orderProductPrice" label="订单成本" width="70" align="right">
        <template #default="row">{{ toBigNumber(row.row.orderProductPrice) }}</template>
      </el-table-column>

      <el-table-column prop="stockinCount" label="入库数" width="65" align="center"> </el-table-column>
      <el-table-column prop="stockinProductPrice" label="入库成本" width="70" align="right">
        <template #default="row">{{ toBigNumber(row.row.stockinProductPrice) }}</template>
      </el-table-column>

      <el-table-column prop="detailChange" label="变动款数" width="65" align="center"> </el-table-column>
      <el-table-column prop="detailTotal" label="总款数" width="60" align="center"> </el-table-column>
      <el-table-column prop="detailRate" label="动销率" width="60" align="center"> </el-table-column>

      <el-table-column prop="daysTotal" label="间隔天数" width="65" align="center"> </el-table-column>
      <el-table-column prop="daysAvgRemain" label="日均库存数" width="80" align="center">
        <template #default="row">{{ (row.row.daysAvgRemain || 0).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column prop="daysAvgProduct" label="日均成本" width="70" align="right">
        <template #default="row">{{ toBigNumber(row.row.daysAvgProduct) }}</template>
      </el-table-column>
      <el-table-column prop="priceRate" label="周转率" width="80" align="center"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'StoreData',
  data() {
    return {
      apiUrl: process.env.VUE_APP_BASEURL,
      valueTime: [],
      paramsObj: {
        keyword: '',
        companyId: '',
        storeCode: '',
        channel: '',
        brand: '',
        startDate: '',
        endDate: ''
      },
      companys: [],
      store: [],
      channels: [],
      storedata: []
    }
  },
  methods: {
    getDefaultCompanyId() {
      const fromStore = (this.$store.getters.getUserInfo || {}).companyID;
      if (fromStore) return fromStore;
      try {
        const raw = sessionStorage.getItem('userInfo');
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed.companyID || '';
      } catch (e) {
        return '';
      }
    },
    fetch() {
      if (!this.paramsObj.companyId) this.paramsObj.companyId = this.getDefaultCompanyId();
      if (!this.paramsObj.companyId) {
        this.$message.warning('请选择公司');
        return;
      }
      if ((!this.valueTime || this.valueTime.length != 2) && (!this.paramsObj.startDate || !this.paramsObj.endDate)) {
        this.$message.warning('请选择时间范围');
        return;
      }
      if (this.valueTime && this.valueTime.length === 2) {
        this.paramsObj.startDate = this.formatTime(this.valueTime[0]);
        this.paramsObj.endDate = this.formatTime(this.valueTime[1]) + ' 23:59:59';
      }

      request({
        url: '/StockStore/ChannelReport',
        method: 'get',
        params: this.paramsObj
      }).then((res) => {
        this.storedata = res.data;
      });
    },
    formatTime(val) {
      return val.getFullYear() + "-" + (val.getMonth() + 1) + "-" + val.getDate();
    },
    toBigNumber(val) {
      if (val == null) { return '-'; }
      else if (Math.round(val) === val && val / 10000 < 1) { return val; }
      else { return this.toNumberFixed(val.toFixed(2)); }
    },
    toNumberFixed(value) {
      const newValue = ['', '', '']
      let fr = 1000
      let num = 3
      let text1 = ''
      let fm = 1
      while (value / fr >= 1) {
        fr *= 10
        num += 1
      }
      if (num <= 4) { // 千
        newValue[0] = value
      } else if (num <= 8) { // 万
        text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万'
        fm = text1 === '万' ? 10000 : 10000000
        if (value % fm === 0) {
          newValue[0] = parseInt(value / fm) + ''
        } else {
          newValue[0] = parseFloat(value / fm).toFixed(2) + ''
        }
        newValue[1] = text1
      } else if (num <= 16) { // 亿
        text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
        text1 = (num - 8) / 4 > 1 ? '万亿' : text1
        text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
        fm = 1
        if (text1 === '亿') {
          fm = 100000000
        } else if (text1 === '千亿') {
          fm = 100000000000
        } else if (text1 === '万亿') {
          fm = 1000000000000
        } else if (text1 === '千万亿') {
          fm = 1000000000000000
        }
        if (value % fm === 0) {
          newValue[0] = parseInt(value / fm) + ''
        } else {
          newValue[0] = parseFloat(value / fm).toFixed(2) + ''
        }
        newValue[1] = text1
      }
      if (value < 1000) {
        newValue[0] = value + ''
        newValue[1] = ''
      }
      return newValue.join('')
    }
    ,
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index >= 9) return;

        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.$util.fmtMoney(sums[index] || '');
        } else {
          sums[index] = '';
        }
      });
      return sums;
    }
  },
  mounted() {
    this.paramsObj.companyId = this.getDefaultCompanyId();
    this.$kaung.dictionary('stock', 'store').then(res => this.store = res);
    this.$kaung.dictionary('stock', 'channel').then(res => this.channels = res);
    this.$kaung.companys().then(res => this.companys = res);
    // 初始化默认时间范围（不设置 date-picker v-model，避免弹框）并自动加载数据
    const range = this.$util.getCurrentDate('month');
    if (range && range.length === 2) {
      this.valueTime = range;
      this.paramsObj.startDate = this.formatTime(range[0]);
      this.paramsObj.endDate = this.formatTime(range[1]) + ' 23:59:59';
    }
  }
}
</script>

<style scoped>
.horizbox { padding: 0; }
</style>

<style lang="less" scoped>
.console-page {
  .el-row {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .box-card {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h4 {
    margin-top: 5px;

    .number {
      color: #409eff;
    }
  }

  .tableshow {
    img {
      transform: scale(1.3, 1.3);
    }
  }

  .showtext {
    line-height: 20px;
    margin-left: 10px;
  }

  .row-bg {
    .el-col {
      padding: 2px 0;
    }

    padding: 10px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-date-editor {
    width: 100%;
    max-width: 280px;
  }

  .text-gray {
    font-family: "PingFang SC";
  }

  .el-table th>.cell {
    padding: 0;
    color: #000;
  }

  .el-table .caret-wrapper {
    width: 12px;
    left: -5px;
  }
}

.panel-group .card-panel:hover {
  background: #a9a9a9;
}

.panel-group .card-panel {
  height: 70px !important;
}

.panel-group .card-panel .card-panel-icon-wrapper {
  margin: 10px 0 0 10px !important;
}

.card-panel .card-panel-description {
  margin-top: 10px !important;
}

@media (max-width: 550px) {
  .card-panel-icon-wrapper {
    width: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
<style lang="less" scoped>
.console-page {
  .el-row {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .box-card {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h4 {
    margin-top: 5px;

    .number {
      color: #409eff;
    }
  }

  .tableshow {
    img {
      transform: scale(1.3, 1.3);
    }
  }

  .showtext {
    line-height: 20px;
    margin-left: 10px;
  }

  .row-bg {
    .el-col {
      padding: 2px 0;
    }

    padding: 10px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-date-editor {
    width: 100%;
    max-width: 280px;
  }

  .text-gray {
    font-family: "PingFang SC";
  }

  .el-table th>.cell {
    padding: 0;
    color: #000;
  }

  .el-table .caret-wrapper {
    width: 12px;
    left: -5px;
  }
}

.panel-group .card-panel:hover {
  background: #a9a9a9;
}

.panel-group .card-panel {
  height: 70px !important;
}

.panel-group .card-panel .card-panel-icon-wrapper {
  margin: 10px 0 0 10px !important;
}

.card-panel .card-panel-description {
  margin-top: 10px !important;
}

@media (max-width: 550px) {
  .card-panel-icon-wrapper {
    width: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
